<template lang="pug">
  .sidebar(:class="{ open: openSidebar }")
    .search
      .search-menu
        .search-title
          span 絞り込む
        .search-row
          span.search-label 営業ステータス
          MultipleSelect(v-model="salesStatus" :options="vSelectSalesStatus")
        .search-row
          span.search-label 営業担当者
          MultipleSelect(v-model="assignedTo" :options="vSelectClientUser")

      .search-button
        input.button-main(
          type="button"
          @click="search"
          value="検索する"
          :disabled="locked")
</template>

<script>
  import { mapGetters } from 'vuex'
  import MultipleSelect from '../parts/MultipleSelect'
  import mapGetSet from '../../libs/map-get-set'
  import searchStartingBusinessList from '../../store/modules/searchStartingBusinessList'

  export default {
    components: { MultipleSelect },
    props: ['openSidebar'],
    mounted () {
      const {
        salesStatus = '',
        assignedTo = '',
      } = this.$route.query

      const master = this.$store.state.master
      this.salesStatus = this.toObjects(salesStatus, master.salesStatuses)
      const clientUsers = this.$store.state.client.detail.client_users
      this.assignedTo = this.toSelected(assignedTo, clientUsers)
    },
    computed: {
      ...mapGetters('client', ['clientUsers']),

      vSelectSalesStatus () {
        return this.$store.state.master.salesStatuses.map(pp => ({ label: pp.name, value: pp.code }))
      },
      vSelectClientUser () {
        return this.clientUsers.map(pp => ({ label: pp.name, value: pp.id }))
      },
      ...mapGetters('master', ['salesStatuses']),
      ...mapGetters({
        apiQuery: 'searchStartingBusinessList/apiQuery',
        locked: 'common/isGlobalLocked',
      }),
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.searchStartingBusinessList.query[k],
        set: ($vm, $s, k, v) => $s.commit(`searchStartingBusinessList/${k}`, v),
        keys: Object.keys(searchStartingBusinessList.state.query),
      }),
    },
    methods: {
      async search () {
        const { name, query } = this.$route
        this.$store.commit('common/lockGlobal')
        try {
          this.$router.push({
            name,
            query: {
              ...this.apiQuery,
              perPage: query.perPage,
              page: '1',
              _t: Date.now(),
            },
          })
        } finally {
          this.$emit('toggleSidebar')
          this.$store.commit('common/unlockGlobal')
        }
      },
      toObjects (ids, masterData) {
        if (!ids) {
          return []
        }

        const isNumber = typeof masterData[0].code === 'number'
        return ids.split(',').reduce((list, id) => {
          const data = isNumber ?
            masterData.find(d => d.code === Number(id)) :
            masterData.find(d => d.code === id)
          if (data) {
            list.push({ label: data.name, value: data.code })
          }
          return list
        }, [])
      },
      toSelected (ids, options) {
        if (!ids) {
          return []
        }
        return ids.split(',').reduce((list, id) => {
          const data = options.find(d => d.id === Number(id))

          if (data) {
            list.push({ label: data.name, value: data.id })
          }
          return list
        }, [])
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessListSidebar.vue